import { redirect } from "react-router-dom";
import { ROUTES } from "src/app/constants";
export const loader = async () => {
  //Redirect to Documents Hub page
  return redirect(ROUTES.WORKERS_COMPENSATION_DOCUMENTS);
};
